<template>
  <div class="layout layout-vr" style="min-width: 1366px;">
    <el-container>
      <el-header>
        <Navbar />
      </el-header>
      <el-main class="layoutmain">
        <AppMain />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { AppMain, Navbar } from './components';
export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar
  },
  computed: {},
  methods: {}
};
</script>
